import React from 'react'
import { useGetWOGContacts } from 'api/query'
import { Table, Tag, Button, Space, Dropdown } from 'antd'
import { PasswordGate, capitalizeWords } from 'helpers'
import { SyncOutlined, CloudUploadOutlined, DownOutlined, ApiOutlined } from '@ant-design/icons'
import { downloadXLSX } from 'helpers/download-xlsx'

const wadotmeurl = 'https://wa.me/62'

const QuizCandidates = () => {
  const {
    data: wogContacts,
    isLoading,
  } = useGetWOGContacts()
  const wogContacsData = wogContacts?.slice().reverse() || []

  const columns = [
    {
      title: 'No.',
      key: 'no',
      render: (_, record, index) => {
        return (
          <div>
            {(currentPage - 1) * pageSize + index + 1}
          </div>
        )
      }
    },
    {
      title: 'Full Name',
      dataIndex: 'fullName',
      key: 'fullName',
      render: (_, record) => (
        <div>
          {capitalizeWords(record.fullName)}
        </div>
      )
    },
    {
      title: 'Phone Number',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
      render: (_, record) => {
        const phoneNumber = record.phoneNumber
        const newPhoneNumber = phoneNumber.split('').slice(1).join('')
        return (
          <a
            href={`${wadotmeurl}${newPhoneNumber}`}
            target='_blank'
            style={{
              textDecoration: 'underline',
            }}
          >
            {phoneNumber}
          </a>
        )
      }
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      render: (_, record) => {
        const email = record.email
        return (
          <a
            href={`mailto:${email}`}
            target='_blank'
            style={{
              textDecoration: 'underline',
            }}
          >
            {email}
          </a>
        )
      }
    },
    {
      title: 'Message',
      dataIndex: 'message',
      key: 'message',
      render: (_, record) => (
        <div>{record.message}</div>
      ),
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (createdAt) => new Date(createdAt).toLocaleString(),
    },
  ]

  const pageSize = 15
  let currentPage = 1

  const isEmpty = wogContacsData.length === 0

  return (
    <PasswordGate correctPassword='neilgabrielle'>
      <main style={{
          backgroundColor: "#F2F2F2",
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: '100vh',
          padding: '4rem',
      }}>
        <div style={{ padding: '0 8.5rem' }}>
          <Button
            type='primary'
            onClick={() => downloadXLSX(wogContacsData)}
            style={isEmpty ? { marginBottom: '1.5rem' } : {}}
            disabled={isEmpty}
          >
            Export Data
          </Button>
          <Table
            columns={columns}
            dataSource={wogContacsData}
            loading={isLoading}
            rowKey="_id"
            pagination={{
              pageSize: pageSize,
              position: ['topCenter', 'bottomCenter'],
              onChange: (page) => {
                currentPage = page;
              }
            }}
          />
        </div>
      </main>
    </PasswordGate>
  )
}

export default QuizCandidates

